import axios from "axios";

export function useAxios() {
  axios.defaults.baseURL = process.env.VUE_APP_CALC_API_URL;
  return axios
}
